/**
 * Formatacao e agrupamento de datas da lista (Secao 6.4).
 *
 * ponytail: usa Intl e Date nativos. A Secao 7.2 pede Temporal com polyfill -
 * troca quando entrar aritmetica de fuso de verdade (adiar, envio agendado),
 * nao para escrever "14:32". O polyfill custa mais que o orcamento da Secao 14.1.
 */

const HOUR = new Intl.DateTimeFormat('pt-BR', { hour: '2-digit', minute: '2-digit' });
const SHORT_DATE = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'short' });
const FULL = new Intl.DateTimeFormat('pt-BR', {
  weekday: 'long',
  day: '2-digit',
  month: 'long',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

function startOfDay(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

/** Hora se for hoje, "12 set" se nao for. */
export function listTime(iso: string, now = new Date()): string {
  const date = new Date(iso);
  return startOfDay(date) === startOfDay(now) ? HOUR.format(date) : SHORT_DATE.format(date);
}

export function fullDate(iso: string): string {
  return FULL.format(new Date(iso));
}

export type DateGroup = 'Hoje' | 'Ontem' | 'Esta semana' | 'Este mês' | 'Mais antigo';

export function dateGroup(iso: string, now = new Date()): DateGroup {
  const days = Math.floor((startOfDay(now) - startOfDay(new Date(iso))) / 86_400_000);
  if (days <= 0) return 'Hoje';
  if (days === 1) return 'Ontem';
  if (days < 7) return 'Esta semana';
  if (days < 31) return 'Este mês';
  return 'Mais antigo';
}

export function fileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB'];
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit++;
  }
  return `${value.toFixed(value < 10 ? 1 : 0).replace('.', ',')} ${units[unit]}`;
}
